import { FC } from "react";
import { CustomerApplicationTask } from "@goodfill/domain-customer-application-types/src/customerApplicationSubmission";
import { Span } from "@goodfill/ui-components";
import { ApplicationPendingTask } from "./ApplicationPendingTask";

export const ApplicationPendingTasksList: FC<{ tasks?: CustomerApplicationTask[] }> = ({ tasks }) => (
  <>
    <Span font={"semibold"} size={"base"}>
      Pending Tasks
    </Span>
    {tasks?.length ? (
      tasks.map((task) => <ApplicationPendingTask key={task.taskNumber} task={task} />)
    ) : (
      <Span>No Pending Tasks</Span>
    )}
  </>
);
